import axios from 'axios'
import {Toast} from 'vant'
import Cookies from 'js-cookie'
import $store from 'vuex'
import {copy} from '@/assets/scripts/helper'
import projectUtil from '@/assets/scripts/project/team'
import {PROJECT_LIST, ORDER_RULES, TEAM_RECOMMEND, PROJECT_TREE} from '@/assets/scripts/api'
import {LOGIN} from "../../assets/scripts/api";

const state = {
  rulePackageProsList: [],
  historyProject: [],
  deleteList: [],
  subscribeMsg: {},
  teamOrderConfig: {},
  teamOrderId: '',
  instanceId: '',
  teamOrderData: {}, //
  submitPrice: {},
  pricing_rules: [],
  changePrice: [],
  allProject: [], //所有项目（未处理过的）
  projectClassList: [], //分类数据
  significance: {},
  specialDisease: [],
  projectList: [], //所有的项目
  ProjectTreeList: [], //树状结构的所有数据
  //packProjectList: [], //当前使用的套餐项目（通常拿的所有套餐方案的第一条 或者 用户选择的）
  orderDataList: [], //所有的套餐方案数据
  checkedProduct: [], //套餐选中项
  checkedProduct_x: [], //1+x中的 x套餐选中项
  materialProjectList: [], // 所有的关联项目
  checkedMaterialProjectList: [], //所有选中的关联项目
  productMaterialProjectList: [], //所有项目包里的关联项目
  productMaterialProjectList_x: [], //所有x项目包里的关联项目
  xMaterialProjectList: [], //所有项目包里的关联项目
  checkedProjectListAll: [], //所有选中项
  addCheckedProjectList: [], //新增选中项
  projectMutexList: {}, //所有的互斥组
  transformationalList: [],
  transformationalList_x: [],
  submitMsg: {},
  recommend: [],
  x: [],
  startRecommend: [], //根据中心，年龄，问卷id等查询处理的数据 (未处理)
  productRecommend: {}, //为上方已处理项目 （没有实际作用，仅仅用来展示，及多个分类。方便用户选择）
  // productPrice: 0,
  price: {},
  alternativePrice: '',
  choosableAllProject: []
  // productxPrice: 0,
  // checkedPrice: 0,
  // priceTotal: 0
}

const mutations = {
  /**
   * 清除所有团检的缓存
   * @param state
   */
  clearTeamData (state) {
    state.x = []
    state.changePrice = []
    state.pricing_rules = []
    state.instanceId = ''
    state.rulePackageProsList = []
    state.deleteList = [] //所有手动删除的项目
    state.historyProject = [] //所有选过的项目
    state.alternativePrice = ''
    state.price = {}
    state.startRecommend = []
    state.submitPrice = {}
    state.submitMsg = {}
    state.significance = {}
    state.projectClassList = []
    state.checkedProjectListAll = []
    state.productRecommend = {}
    state.transformationalList = []
    state.transformationalList_x = []
    state.productMaterialProjectList = []
    state.productMaterialProjectList_x = []
    state.projectMutexList = {}

    state.allProject = []
    state.orderDataList = []
    state.checkedMaterialProjectList = []
    state.ProjectTreeList = []
    state.recommend = []
  },
  clearMaterialProjectList (state) {
    state.checkedMaterialProjectList = []
  },
  setPricingRules (state, data) {
    state.pricing_rules = data
  },
  setRulePackagePros (state, data) {
    let list = state.projectList
    let starList = []
    let rulePackageProsIdList = []
    let rulePackageProsList = []
    data.forEach((obj, index) => {
      if (obj.testMothodPro.basePackagePros) {
        starList = starList.concat(obj.testMothodPro.basePackagePros || [])
      }
      if (index === data.length - 1) {
        obj.testMothodPro.rulePackagePros.forEach(item => {
          rulePackageProsIdList.push(item.projectId)
          let isIndex = starList.findIndex($i => {
            return $i.projectId === item.projectId
          })
          if (isIndex > 0) {
            starList[isIndex].counditionInfoList = item.counditionInfoList
            starList[isIndex].star = item.star
          } else {
            starList.push(item)
          }
        })
      }
    })
    starList.forEach(project => {
      for (var i = 0; i < list.length; i++) {
        if (project.projectId === list[i].id) {
          list[i].star = project.star
          if (rulePackageProsIdList.includes(project.projectId)) {
            list[i].counditionInfoList = project.counditionInfoList || []
            list[i].coundtionInfoCode = true
            rulePackageProsList.push(list[i])
          }
          break
        }
      }
    })
    state.rulePackageProsList = rulePackageProsList
    state.projectList = list
  },
  // setRulePackagePros (state, data) {
  //   let list = state.projectList
  //   data.forEach(project => {
  //     for (var i = 0; i < list.length; i++) {
  //       if (project.projectId === list[i].id) {
  //         console.log(project)
  //         list[i].counditionInfoList = project.counditionInfoList || []
  //         list[i].star = project.star
  //         break
  //       }
  //     }
  //   })
  //   state.projectList = list
  // },
  setStartRecommend (state, data) { //存储根据中心，年龄，问卷id等查询处理的数据 (未处理)
    state.startRecommend = data
  },
  setDeleteList (state, data) {
    state.deleteList = data
  },
  setHistoryProject (state, data) {
    let historyList = state.historyProject
    data.forEach(obj => {
      if (!historyList.length || !historyList.some(item => {
        return item.id === obj.id
      })) {
        historyList.push(JSON.parse(JSON.stringify(obj)))
      }
    })
    console.log(historyList)
    state.historyProject = historyList
  },
  setSignificance (state, data) {
    state.significance = data
  },
  setProjectListTree (state, data) {
    state.projectListTree = data
  },
  setChoosableAllProject (state, data) { //设置可选包
    state.choosableAllProject = data
  },
  setProductRecommend (state, data) { //处理数据
    let base = {
      base: [],
      recommend: [],
      accurate: [],
      thorough: []
    }
    state.projectList.forEach($item => {
      if (!$item.coundtionInfoCode || state.startRecommend[0].testMothodPro.rulePackagePros.find((p) => p.projectId === $item.id && p.fromBase === 1) || state.startRecommend[0].testMothodPro.basePackagePros.find((p) => p.projectId === $item.id)) {
        if (state.startRecommend[0].testMothodPro.basePackagePros.find((p) => p.projectId === $item.id) || state.startRecommend[0].testMothodPro.rulePackagePros.find((p) => p.projectId === $item.id && p.fromBase === 1)) {
          if (!$item.coundtionInfoCode) {
            $item.visible && base.base.push($item)
          }

          $item.isNewRecommend = '1'
        } else if (state.startRecommend[1].testMothodPro.basePackagePros.find((p) => p.projectId === $item.id)) {
          $item.visible && base.recommend.push($item)
        } else if (state.startRecommend[2].testMothodPro.basePackagePros.find((p) => p.projectId === $item.id)) {
          $item.visible && base.accurate.push($item)
        } else if (state.startRecommend[3].testMothodPro.basePackagePros.find((p) => p.projectId === $item.id)) {
          $item.visible && base.thorough.push($item)
        }
      }
    })
    state.productRecommend = base
  },
  setTeamOrderId (state, data) { //设置订单id
    state.teamOrderId = data
  },
  setSelectAlternativePrice (state, data) {
    state.alternativePrice = data
  },
  setSubmitMsg (state, data) { //设置订单id
    state.submitMsg = data
  },
  setSubmitPrice (state, data) { //设置订单
    state.submitPrice = data
  },
  setInstanceId (state, data) { //设置用户用到的问卷数据
    state.instanceId = data
  },
  setTeamOrderData (state, data) { //设置订单详情数据（含订单号等，（未确认之前）不包含订单项目）
    state.teamOrderData = data
  },
  setOrderDataList (state, data) { //设置添加过checked属性的团检订单项目 原始数据
    state.orderDataList = data
  },
  setProduct_x (state, data) {
    state.x = data
  },
  setSubscribeMsg (state, data) {
    state.subscribeMsg = data
  },
  setProjectClassList (state, data) {
    state.projectClassList = data.filter((project) => {
      if (project.items && project.items.length > 0) {
        project.item = project.itemName
        project.parentItemId = ''
        return project
      } else {
        return false
      }
    })
  },
  setTeamOrderConfig (state, data) {
    state.teamOrderConfig = data
  },
  setAllProject (state, data) { //未处理项目数据 （包含关联项目集合 ， 所有项目数据集合， 专病集合）
    state.allProject = data
  },
  setProjectList (state, data) { //设置所有项目
    state.projectList = data
  },
  setProjectTreeList (state, data) { //获取树型结构
    let isTreeList = data
    state.projectTreeList = projectUtil.replaceTree(state.projectList, isTreeList)
  },
  setProjectMutexList (state, data) {
    state.projectMutexList = projectUtil.getProjectMutexList(data)
    //   let allList = {}
    //   data.filter(obj => {
    //     return obj.typable === '1' && !obj.visible && obj.children
    //   }).forEach(obj => {
    //     if (allList[obj.id] === undefined && obj.children) {
    //       obj.children.forEach(item => {
    //         let projectList = state.projectList
    //         for (let $index = 0; $index < projectList.length; $index++) {
    //           if (projectList[$index].id === item.id) {
    //             item = projectList[$index]
    //             return
    //           }
    //         }
    //       })
    //     }
    //     allList[obj.id] = obj.children
    //   })
    // state.recommendSubProjectsAll = allList //所有的互斥组
    //   console.log(allList)
  },
  getCheckedProjectList (state) {
    //初始化获取选中的项目 (从项目中替换)
    let packData_x = JSON.parse(JSON.stringify(state.x.filter(obj => {
      return obj.checked
    }))) //x 套餐

    let packProjectList_x = (packData_x.length && packData_x[0].packageProjects) || [] //套餐所有项目
    let relation_x = (packData_x.length && packData_x[0].partitionedProjects) || [] //转换关系映射表
    let relationId_x = []
    relation_x.forEach(obj => { // x套餐项目的遍历
      obj.partitionProjects.split(',').forEach(id => {
        if (!relationId_x.includes(id)) {
          relationId_x.push(id)
        }
      })
    })
    let packData = JSON.parse(JSON.stringify(state.orderDataList.filter(obj => {
      return obj.checked
    }))) //基础套餐
    let packProjectList = (packData.length && packData[0].packageProjects) || [] //套餐所有项目
    let relation = (packData.length && packData[0].partitionedProjects) || [] //转换关系映射表
    let relationId = []
    relation.forEach(obj => {
      //基础套餐项目的遍历
      obj.partitionProjects.split(',').forEach(id => {
        if (!relationId.includes(id)) {
          relationId.push(id)
        }
      })
    })
    var projectAll = [], materialProduct = [], checkedProduct = [], relationProduct = [], relationProductId = [],
      materialProduct_x = [], checkedProduct_x = [], relationProduct_x = [], relationProductId_x = []
    /**
     * projectAll 保存所有选中的项目
     * materialProduct 所有项目包里的关联项目
     * checkedProduct 保存所有基础套餐选中项目
     * relationProduct 存储基础套餐中的转换关系
     * relationProductId 保存所有存储基础套餐中的转换项目的id 初始化就不会被初始化到套餐中去
     **/
    state.projectList.forEach(item => {
      if (item.typable === '0') {
        state.recommend.forEach(obj => {
          //设置推荐
          if (obj.id === item.id) item.recommend = '1'
        })
        item.isReplace = '1' //1可替换
        item.packable = '0' // 是否在套餐中 1 为基础套餐  x为x套餐
        item.recalculate = item.recalculate.toString() //重新计价
        packProjectList_x.forEach(obj => {
          if (obj.id === item.id) {
            if (state.projectList.some($item => {
              return $item.id === obj.id && $item.recalculate === '0'
            })) {
              //在项目中
              item.count = obj.num
              item.reduce = 0
              item.isReplace = obj.isReplace.toString()
              item.price = typeof obj.discountPrice === 'number' ? obj.discountPrice : obj.price || 0
              item.packable = 'x'
              projectAll.push(item)
              checkedProduct_x.push(item)
            } else {
              state.allProject.materialList.forEach($item => {
                // 为关联项目的
                if (obj.id === $item.id && !materialProduct_x.some($obj => {
                  return $obj.id === $item.id
                })) {
                  materialProduct_x.push(Object.assign({}, $item, {
                    count: obj.num,
                    reduce: 0,
                    isReplace: obj.isReplace.toString(),
                    price: typeof obj.discountPrice === 'number' ? obj.discountPrice : obj.price || 0
                  }))
                } else if (obj.id === $item.id) {
                  //预留考虑 配置多个可重复计费项目
                }
              })
            }
          }
        })
        packProjectList.forEach(obj => {
          if (state.projectList.some($item => {
            return $item.id === obj.id
          })) {
            if (item.recalculate !== undefined && item.recalculate.toString() === '0' && obj.id === item.id) {
              item.count = obj.num
              item.packable = '1'
              item.reduce = 0
              item.price = typeof obj.discountPrice === 'number' ? obj.discountPrice : obj.price || 0
              item.isReplace = obj.isReplace.toString()
              projectAll.push(item)
              checkedProduct.push(item)
            } else if (obj.id === item.id) {
              materialProduct.push(Object.assign({}, item, {
                count: obj.num,
                packable: '1',
                reduce: 0,
                isReplace: obj.isReplace.toString(),
                recalculate: item.recalculate,
                price: typeof obj.discountPrice === 'number' ? obj.discountPrice : obj.price || 0
              }))
            }
          } else {
            state.allProject.materialList.forEach($item => {
              if (obj.id === $item.id && !materialProduct.some($obj => {
                return $obj.id === $item.id
              })) {
                materialProduct.push(Object.assign({}, $item, {
                  count: obj.num,
                  packable: '1',
                  reduce: 0,
                  isReplace: obj.isReplace.toString(),
                  // recalculate: $item.recalculate,
                  price: typeof obj.discountPrice === 'number' ? obj.discountPrice : obj.price || 0
                }))
              }
            })
          }
        })
        //转换项目
        relation_x.forEach(obj => {
          if (obj.originalProjectId === item.id) relationProduct_x.push(Object.assign({partitionProjects: obj.partitionProjects.split(',')}, item))
        })
        relation.forEach(obj => {
          if (obj.originalProjectId === item.id) {
            relationProduct.push(Object.assign({partitionProjects: obj.partitionProjects.split(',')}, item))
          }
        })
      }
    })
    relationProduct_x.forEach(obj => {
      obj.partitionProjects.forEach((item, index) => {
        if (item && state.projectList.filter($item => {
          return $item.id === item
        }).length) {
          state.projectList.forEach($item => {
            if ($item.id === item) obj.partitionProjects.splice(index, 1, Object.assign({}, $item))
          })
        } else if (item) {
          state.allProject.materialList.forEach($item => {
            if ($item.id === item) obj.partitionProjects.splice(index, 1, Object.assign({}, $item))
          })
        }
      })
    })

    relationProduct.forEach(obj => {
      obj.partitionProjects.forEach((item, index) => {
        if (item && state.projectList.filter($item => {
          return $item.id === item
        }).length) {
          state.projectList.forEach($item => {
            if ($item.id === item) obj.partitionProjects.splice(index, 1, Object.assign({}, $item))
          })
        } else if (item) {
          state.allProject.materialList.forEach($item => {
            if ($item.id === item) obj.partitionProjects.splice(index, 1, Object.assign({}, $item))
          })
        }
      })
    })
    state.checkedProduct = checkedProduct
    state.transformationalList = relationProduct //转换关系
    state.productMaterialProjectList = materialProduct //关联项目
    // console.log(checkedProduct, projectAll)
    state.checkedProduct_x = checkedProduct_x
    state.transformationalList_x = relationProduct_x
    state.productMaterialProjectList_x = materialProduct_x
    state.checkedProjectListAll = projectAll
    state.historyProject = JSON.parse(JSON.stringify(projectAll))
  },
  setCheckedData (state, data) {
    state.productMaterialProjectList = data.productMaterial
    state.productMaterialProjectList_x = data.xproductMaterial
    state.checkedProjectListAll = data.project
    state.checkedMaterialProjectList = data.checkedmaterialList
  },
  setRecommend (state, data) {
    state.recommend = data
  },
  getPrice (state) {
    let productPrice = 0
    let productxPrice = 0
    let checkedPrice = 0
    let isNewRecommendPrice = 0
    let pricing_rules_list = {}
   let product_hasRules = state.pricing_rules.filter(rulesItem =>  state.checkedProduct.some(productItem =>  rulesItem.id === productItem.id && state.checkedProjectListAll.some(chose=> chose.id === productItem.id )))
    state.pricing_rules.forEach(rules => {
      state.checkedProduct.forEach(productItem => {
        if(rules.id === productItem.id){
          console.log(productItem)
          let chose = state.checkedProjectListAll.some($chose => $chose.id === rules.id)  //是否为已选
          let disCount = parseFloat((productItem.price / rules.price).toFixed(2))
          if(rules.subList && rules.subList.length){
            rules.subList.forEach(subItem => {

              if(subItem.recalculate === 0){
                let price =  parseFloat((disCount * subItem.price).toFixed(2))
                if( (!pricing_rules_list.hasOwnProperty(subItem.projectId) || pricing_rules_list[subItem.projectId].price > price) &&
                  (chose || !product_hasRules.some(hasRulesItem => hasRulesItem.subList.some(hasRulesChild =>  hasRulesChild.projectId === subItem.projectId)) )
                ){
                  pricing_rules_list[subItem.projectId] = {
                    id: rules.id,
                    price: price,
                    code: 'product'
                  }
                }
              }
            })
          }
        }
      })
    })
    state.checkedProduct.forEach(obj => {
      if (!state.checkedProjectListAll.some($obj => {
        return $obj.id === obj.id
      })) {
        let rules_item = state.pricing_rules.find($item => $item.id === obj.id)
        let decreasePrice = 0
        if (rules_item) {
          rules_item.subList.forEach(subItem=>{
            if(subItem.recalculate === 0 && pricing_rules_list.hasOwnProperty(subItem.projectId) &&pricing_rules_list[subItem.projectId].id !== rules_item.id){
              decreasePrice += (subItem.price.toString().movePoint(2) * parseFloat((obj.price / rules_item.price).toFixed(2)))
            }
          })
          productPrice = (obj.price.toString().movePoint(2) - decreasePrice + productPrice.toString().movePoint(2)).toString().movePoint(-2)
        } else {
          productPrice = (obj.price.toString().movePoint(2) + productPrice.toString().movePoint(2)).toString().movePoint(-2)
        }
      }
    })
    state.productMaterialProjectList.forEach(obj => {
      if (obj.reduce > 0) {
        productPrice = ((obj.reduce * obj.price.toString().movePoint(2)) + productPrice.toString().movePoint(2)).toString().movePoint(-2)
      }
    })
    state.checkedProduct_x.forEach(obj => {
      if (!state.checkedProjectListAll.some($obj => {
        return $obj.id === obj.id
      })) {
        productxPrice = (obj.price.toString().movePoint(2) + productxPrice.toString().movePoint(2)).toString().movePoint(-2)
      }
    })
    state.productMaterialProjectList_x.forEach(obj => {
      if (obj.reduce > 0) {
        productxPrice = ((obj.reduce * obj.price.toString().movePoint(2)) + productxPrice.toString().movePoint(2)).toString().movePoint(-2)
      }
    })

    let oneDiscountPrice = 0
    let againDiscountPrice = 0
    let notMaterialProjectList = 0
    let $customPrice = state.alternativePrice === 0 ? 0 : (state.teamOrderData.customPrice || state.alternativePrice || 0).toString().movePoint(2) //自选项目金额
    let $productPrice = productPrice.toString().movePoint(2) //基础套餐被替换项目金额
    let $productxPrice = productxPrice.toString().movePoint(2) //x套餐被替换项目金额
    let $optional = $customPrice + $productPrice + $productxPrice //用户可自选的总额 =  x套餐（被替换项目金额） +  基础套餐（被替换项目金额） + 自选金额
    let discountUnit = state.teamOrderConfig.discountUnit //单位折扣
    let discountUser = state.teamOrderConfig.discountUser //用户折扣
    let productR = $productPrice + $productxPrice
    let oneDiscountPriceList = []
    let againDiscountPriceList = []
    // console.log( state.checkedProjectListAll)
    // pricing_rules_list
    let checked_rules_list = {}

    state.checkedProjectListAll.sort((a,b)=>{
      return b.price- a.price
    }).forEach(obj => {
      if (!obj.packable || (obj.packable !== undefined && obj.packable.toString() !== '1' && obj.packable.toString() !== 'x' && !state.checkedMaterialProjectList.some($item => {
        return $item.id === obj.id
      }))) {
        let rules_item = state.pricing_rules.find($item => $item.id === obj.id)
        // let price = 0

        if(rules_item){
          let disCount =  parseFloat((obj.price / rules_item.price).toFixed(2))
          rules_item.subList.forEach(subItem=>{
            let price =  parseFloat((disCount * subItem.price).toFixed(2))

            // let chose = state.checkedProjectListAll.some($chose => $chose.id === rules.id)  //是否为已选
            if(subItem.recalculate === 0 && (!pricing_rules_list.hasOwnProperty(subItem.projectId) || !state.checkedProjectListAll.some($chose => $chose.id === pricing_rules_list[subItem.projectId].id))  &&
                (!checked_rules_list.hasOwnProperty(subItem.projectId) || checked_rules_list[subItem.projectId].price > price  )){
              console.log(subItem)
              checked_rules_list[subItem.projectId] = {
                id: rules_item.id,
                price: price
              }
            }
          })
        }
      }
    })
    state.checkedProjectListAll.forEach(obj => {
      console.log(obj)
      if (!obj.packable || (obj.packable !== undefined && obj.packable.toString() !== '1' && obj.packable.toString() !== 'x' && !state.checkedMaterialProjectList.some($item => {
        return $item.id === obj.id
      }))) {
        let rules_item = state.pricing_rules.find($item => $item.id === obj.id)
        let price = obj.price
        let reducePrice= 0
        if(rules_item){
          rules_item.subList.forEach(subItem=>{
            if(subItem.recalculate === 0 &&  (!checked_rules_list.hasOwnProperty(subItem.projectId)  || checked_rules_list[subItem.projectId].id !== rules_item.id)){
              reducePrice += (subItem.price.toString().movePoint(2) * parseFloat((obj.price / rules_item.price).toFixed(2)))
            }
          })
          price =  price.toString().movePoint(2) -  reducePrice
        } else {
          price =  price.toString().movePoint(2)
        }
        let newUnitPrice = (price * discountUnit).toString().movePoint(-1)
        let newUserPrice = (price * discountUser).toString().movePoint(-1)
        if (obj.againDiscount === '1') {
          againDiscountPriceList.push(Object.assign({ newUnitPrice: newUnitPrice, newUserPrice: newUserPrice }))
        } else {
          oneDiscountPrice += price
        }
        if (obj.isNewRecommend === '1') isNewRecommendPrice = Number((price + isNewRecommendPrice.toString().movePoint(2)).toString().movePoint(-2).toFixed(2))
        checkedPrice = Number((price + checkedPrice.toString().movePoint(2)).toString().movePoint(-2).toFixed(2))
        notMaterialProjectList = Number((price + notMaterialProjectList.toString().movePoint(2)).toString().movePoint(-2).toFixed(2))
      }
    })


    state.checkedMaterialProjectList.forEach(obj => {

      if (obj.recalculate.toString() === '1') {
        let newUnitPrice = ((obj.count || 1) * obj.price.toString().movePoint(2) * discountUnit).toString().movePoint(-1)
        let newUserPrice = ((obj.count || 1) * obj.price.toString().movePoint(2) * discountUser).toString().movePoint(-1)

        if (obj.againDiscount === '1') {
          againDiscountPriceList.push(Object.assign({newUnitPrice: newUnitPrice, newUserPrice: newUserPrice}))
        } else {
          oneDiscountPrice += (obj.count || 1) * obj.price.toString().movePoint(2)
        }
        if (obj.isNewRecommend === '1') isNewRecommendPrice = Number(((obj.count || 1) * obj.price.toString().movePoint(2) + isNewRecommendPrice.toString().movePoint(2)).toString().movePoint(-2).toFixed(2))
        checkedPrice = Number((((obj.count || 1) * obj.price.toString().movePoint(2) + checkedPrice.toString().movePoint(2)).toString().movePoint(-2)).toFixed(2))

      } else {

        let rules_item = state.pricing_rules.find($item => $item.id === obj.id)
        let price = 0
        if(rules_item){
          rules_item.subList.forEach(subItem=>{
            if(subItem.recalculate === 0 && !checked_rules_list.hasOwnProperty(subItem.projectId) &&  (!pricing_rules_list.hasOwnProperty(subItem.projectId) || !state.checkedProjectListAll.some(allItem => allItem.id === pricing_rules_list[subItem.projectId].id ))){
              checked_rules_list[subItem.projectId] = {
                id: rules_item.id,
                price: subItem.price
              }
            } else if(subItem.recalculate === 0){
              price += parseFloat(subItem.price.toString().movePoint(2) * parseFloat((obj.price / rules_item.price).toFixed(2)).toFixed(2))
            }
          })
        }
        let bafo =  price > 0 ? obj.price.toString().movePoint(2) - price : obj.price.toString().movePoint(2)
        let newUnitPrice = (bafo * discountUnit).toString().movePoint(-1)
        let newUserPrice = (bafo * discountUser).toString().movePoint(-1)
        if (obj.againDiscount === '1') {
          againDiscountPriceList.push(Object.assign({newUnitPrice: newUnitPrice, newUserPrice: newUserPrice}))
        } else {
          oneDiscountPrice += bafo
        }
        if (obj.isNewRecommend === '1') isNewRecommendPrice = Number((bafo + isNewRecommendPrice.toString().movePoint(2)).toString().movePoint(-2).toFixed(2))

        checkedPrice = Number(((bafo + checkedPrice.toString().movePoint(2)).toString().movePoint(-2)).toFixed(2))
      }
    })

    againDiscountPriceList.sort((a, b) => {
      return b.newUnitPrice - a.newUnitPrice
    })
    againDiscountPriceList.forEach(obj => {
      if (againDiscountPrice + obj.newUnitPrice < $optional) {
        againDiscountPrice += obj.newUnitPrice
      } else {
        oneDiscountPriceList.push(obj)
      }
    })
    oneDiscountPriceList.forEach(obj => {
      againDiscountPrice += obj.newUserPrice
    })

    //实际计算价格       againDiscount—可二次折扣        oneDiscount—不能折扣
    let dist = ($optional - (againDiscountPrice + oneDiscountPrice)).toFixed(0).movePoint(-2)
console.log(againDiscountPrice, oneDiscountPrice, checkedPrice, isNewRecommendPrice)
    let params = {
      x: productxPrice, //x套餐被替换额度
      productR: Number(productR.toString().movePoint(-2).toFixed(2)),
      productPrice: productPrice, //套餐被替换额度
      customPrice: Number($customPrice.toString().movePoint(-2).toFixed(2)), //自选金额
      checkedPrice: checkedPrice, //折扣前 已选总额
      notMaterialProjectList: notMaterialProjectList,
      isNewRecommendPrice: isNewRecommendPrice,
      subtotal: Number((checkedPrice.toString().movePoint(2) - isNewRecommendPrice.toFixed(0).movePoint(2)).toString().movePoint(-2).toFixed(2)),
      discountCheckedPrice: Number((againDiscountPrice + oneDiscountPrice).toFixed(0).movePoint(-2).toFixed(2)), //折后总额
      optional: Number($optional.toString().movePoint(-2).toFixed(2)), // 折前总额
      surplus: Number(Math.abs(dist).toFixed(2)), // 可选或可用总额
      submit: dist > 0 ? '+' : '-',
      text: dist > 0 ? '还可用' : '待支付'
    }
    console.log(params)
    state.price = params
  },
  initProjectClassList (state) {
    state.projectClassList = state.projectClassList.map((projectClass) => {
      let pro
      let items = []
      projectClass.items.forEach(p => {
        for (let item of state.projectList) {
          if (item.id === p.projectId) {
            item.parentItemId = projectClass.id
            pro = copy(item)
            pro.stress = p.stress
            items.push(pro)
            break
          }
        }
      })
      let projectMutexList = []
      state.projectTreeList.forEach(directory => {
        if (directory.children) {
          projectMutexList = projectMutexList.concat(directory.children.filter(project => {
            return project.children && project.children.length
          }))
        }
      })
      let children = []
      projectMutexList.forEach(mutex => {
        let mutexList = []
        mutex.children.forEach(mutexProject => {
          items.forEach(project => {
            if (project.id === mutexProject.id) {
              project.parentItemId = projectClass.id
              mutexList.push(project)
            }
          })
        })
        let {id, inspectionSignificance, orderNum, parentId, parentName, typable} = mutex
        if (mutexList && mutexList.length > 1) {
          children.push({
            children: mutexList,
            item: projectClass.item,
            mutexItem: mutex.item.replace(/[0-9]+/, mutexList.length),
            typable: '1',
            id,
            inspectionSignificance,
            orderNum,
            parentId,
            parentName
          })
        }
      })
      items.forEach(project => {
        if (!children.length || !children.some(mutex => {
          return (!mutex.children && mutex.id === project.id) || (mutex.children && mutex.children.some(mutexProject => {
            return mutexProject.id === project.id
          }))
        })) {
          children.push(project)
        }
      })
      projectClass.items = children
      // console.log(projectClass)
      return projectClass
    }).sort(function (a, b) {
      return ((a.rowIndex < b.rowIndex) ? -1 : ((a.rowIndex > b.rowIndex) ? 1 : 0))
    })
    // state.projectClassList = state.projectClassList.map((projectClass) => {
    //   let pro
    //   let items = []
    //   projectClass.items.forEach(p => {
    //     for (let item of state.projectList) {
    //       if (item.id === p.projectId) {
    //         item.parentItemId = projectClass.id
    //         pro = copy(item)
    //         pro.stress = p.stress
    //         items.push(pro)
    //         break
    //       }
    //     }
    //   })
    //   let projectMutexList = []
    //   state.projectTreeList.forEach(directory => {
    //     if (directory.children) {
    //       projectMutexList = projectMutexList.concat(directory.children.filter(project => { return project.children && project.children.length }))
    //     }
    //   })
    //   let children = []
    //   projectMutexList.forEach(mutex => {
    //     let mutexList = []
    //     mutex.children.forEach(mutexProject => {
    //       items.forEach(project => {
    //         if (project.id === mutexProject.id) {
    //           project.parentItemId = projectClass.id
    //           mutexList.push(project)
    //         }
    //       })
    //     })
    //     let {id, inspectionSignificance, orderNum, parentId, parentName, typable} = mutex
    //     if (mutexList && mutexList.length > 1)
    //       children.push({
    //         children: mutexList,
    //         item: projectClass.item,
    //         mutexItem: mutex.item.replace(/[0-9]+/, mutexList.length),
    //         typable: '1',
    //         id,
    //         inspectionSignificance,
    //         orderNum,
    //         parentId,
    //         parentName
    //       })
    //   })
    //   items.forEach(project => {
    //     console.log(project)
    //     if (project && (!children.length || !children.some(mutex => { return (!mutex.children && mutex.id === project.id) || (mutex.children && mutex.children.some(mutexProject => {return mutexProject.id === project.id }) )}))) {
    //       children.push(project)
    //     }
    //   })
    //   projectClass.items = children
    // }).sort(function (a, b) {
    //   return ((a.rowIndex < b.rowIndex) ? -1 : ((a.rowIndex > b.rowIndex) ? 1 : 0))
    // })
    // console.log(state.projectClassList)
  },
}
const actions = {
  /**
   * 根据用户信息获取可自选的体检项目数据
   * @param commit
   * @param state
   * @param params 年龄,性别,婚姻状况,体检中心ID
   * @returns {Promise<void>}
   */
  loadProjectData: async function ({commit, state}, params) {
    commit('clearTeamData')
    let {data} = await axios.get(PROJECT_LIST, {
      params: params
    })
    data.projectList = data.projectList.filter(obj => {
      return !obj.children || obj.children.length === 0
    })
    var significance = {}
    // let projectClassList = data.projectClassList.filter(obj => { return obj.items && obj.items.length > 0 })
    if (state.choosableAllProject && state.choosableAllProject.length) {
      let productMuteId = []
      data.projectList.forEach(obj => {
        obj.visible = 0
        state.choosableAllProject.forEach($obj => {
          if (obj.id === $obj.projectId) {
            obj.visible = 1
            obj.price = typeof $obj.discountPrice === 'number' ? $obj.discountPrice : $obj.price || 0
            obj.againDiscount = $obj.againDiscountSwitch
            obj.discount = $obj.discount
          }
        })

        if (state.teamOrderData.testPackage && state.teamOrderData.testPackage.packageProjects) {
          state.teamOrderData.testPackage.packageProjects.concat(state.teamOrderData.testPackage.packageProjectsForGift).forEach(t => {
            if (obj.id === t.id) {
              if (obj.recalculate.toString() === '0') obj.visible = 1
              obj.price = typeof t.discountPrice === 'number' ? t.discountPrice : t.price || 0
              obj.discount = t.discount
              if (obj.mutexId) productMuteId.concat(obj.mutexId.split(','))
            }
          })
        }
        // projectClassList.forEach($obj => {
        //   if (!significance[$obj.id]) { significance[$obj.id] = {} }
        //   $obj.items.forEach((project, index) => {
        //     if (project.projectId === obj.id) {
        //       obj.projectClassList = true
        //       if (obj.projectClass) {
        //         obj.projectClass.push({id: $obj.id, name: $obj.itemName})
        //       } else {
        //         obj.projectClass = []
        //         obj.projectClass.push({id: $obj.id, name: $obj.itemName})
        //       }
        //       $obj.items.splice(index, 1, obj)
        //       significance[$obj.id][project.projectId] = project.stress
        //     }
        //   })
        // })
      })

      data.materialList.forEach(obj => {
        state.choosableAllProject.forEach($obj => {
          if (obj.id === $obj.projectId) {
            obj.price = $obj.discountPrice
            obj.againDiscount = $obj.againDiscountSwitch
            obj.discount = $obj.discount
          }
        })
      })
    }
    // console.log(projectClassList)
    commit('setSignificance', significance) //保存获取的原始数据
    let {materialList, projectList, showPrice} = data
    commit('setAllProject', {materialList, projectList, showPrice}) //保存获取的原始数据
    commit('setProjectList', data.projectList) //设置所有项目
    commit('setProjectListTree', data.projectListTree)
    commit('setProjectClassList', data.projectClassList) //保存获取的原始数据
    let pricing_rules = await axios.get('/center-service/v1/project/pricing_rules/' + params.sysCenterId)
    commit('setPricingRules', pricing_rules.data)
    // commit('setProjectTreeList', data.projectList) //获取树状结构
    // commit('setRecommendSubProjectsAll', data.projectList) // 获取所有的互斥组
  },
  loadProjectTree: async function ({commit, state}, params) {
    commit('setProjectTreeList', state.projectListTree)
    commit('setProjectMutexList', state.projectListTree)
  },
  /**
   * 根据用户信息获取订单数据
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  loadOrderData: async function ({commit, state}) {
    let {data} = await axios.get(ORDER_RULES, {
      params: {
        _BIZCODE: '0002',
        orderId: state.teamOrderData.id
      }
    })
    data.forEach(obj => {
      obj.checked = false
      obj.fullName = (obj.packageName ? (obj.packageName) : '') +
        (obj.customPrice > 0 ? ((obj.packageName ? '+' : '') + obj.customPrice + '元自选金额') : '') +
        (obj.planTypeCode === 'topic' ? ' + 自选专项套餐(' + obj.topicCount + ')' : '')
    })
    if (state.teamOrderData.packageId) {
      data.forEach(obj => {
        if (obj.packageId === state.teamOrderData.packageId) {
          obj.checked = true
          commit('setSelectAlternativePrice', obj.customPrice || 0)
        }
      })
    } else {
      data[0].checked = true
    }

    if (state.teamOrderData.topicPackageList && state.teamOrderData.topicPackageList.length) {
      commit('setOrderDataList', [data[0]])
      let arr = data.filter(obj => {
        return obj.packageId !== data[0].packageId
      })
      arr[0].checked = true
      commit('setProduct_x', arr)
    } else {
      commit('setOrderDataList', data)
    }
    commit('getCheckedProjectList')
    commit('getPrice')
  },
  /**
   * 新增项目
   * @param commit
   * @param state
   * @project project
   * @returns {Promise<void>}
   */
  checkProject: async function ({commit, state}, project) {
    if (project) {
      let checkedList = state.checkedProjectListAll || []//所有选中项
      let mutexList = state.projectMutexList || []
      let projectList = state.projectList || []
      let checkedMaterialProjectList = state.checkedMaterialProjectList || []
      let materialListAll = state.allProject.materialList || []
      let productMaterialProjectList = state.productMaterialProjectList || []
      let productMaterialProjectList_x = state.productMaterialProjectList_x || []
      let productPrice = state.productPrice
      let checkedPrice = state.checkedPrice
      let delList = JSON.parse(JSON.stringify(state.deleteList)) || []
      if (checkedList.length && checkedList.some(obj => {
        return obj.id === project.id
      })) { //delete
        /**
         * 取消
         * 1.判断是不是套餐项目（套餐项目不能被取消）
         * 2.找互斥组       2.1 不含互斥组：下一步      2.2 含互斥组： 若互斥组中有为套餐项目的   则直接进行选套餐项目的处理  ///  由于有2.2存在，最好在vuex中处理
         * **/
        if (project.packable !== undefined && (project.packable.toString() === '1' || project.packable.toString() === 'x')) {
          Toast.fail({
            duration: 3000,
            forbidClick: true,
            message: `该项目【${project.item}】为套餐项目，无法取消`
          })
        } else {
          delList.push(project.id)
          commit('setDeleteList', delList)
          let MUTEX = []
          console.log(project.mutexId)
          if (project.mutexId) {
            project.mutexId.split(',').forEach($MUTEXID => {
              if ($MUTEXID && mutexList[$MUTEXID] && mutexList[$MUTEXID].length) {
                mutexList[$MUTEXID].forEach($project => {
                  if ($project.id !== project.id && (state.checkedProduct.some($item => {
                    return $item.id === $project.id
                  }) || state.checkedProduct_x.some($item => {
                    return $item.id === $project.id
                  }))) {
                    // console.log($project)
                    MUTEX.push($project)
                    // console.log( projectUtil.getCheckedProjectList($project, projectList, checkedList))
                  }
                })
              }
            })
          }
          if (MUTEX.length) {
            commit('setCheckedData', projectUtil.getCheckedProjectMUTEX(MUTEX, checkedList, projectList, mutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, productMaterialProjectList_x))
          } else if (!checkedMaterialProjectList.some(obj => {
            return obj.id == project.id
          })) {
            commit('setCheckedData', projectUtil.getUnSelectProject(project, checkedList, projectList, mutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, productMaterialProjectList_x))
          }
        }
      } else if(!checkedMaterialProjectList.some(obj => {
        return obj.id === project.id
      })){ //add
        let projectLIST_add = projectUtil.getCheckedProject(project, checkedList, projectList, mutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, productMaterialProjectList_x)
        if (delList && delList.length && delList.includes(project.id)) {
          commit('setDeleteList', delList.filter($p => {
            return $p !== project.id
          }))
        }
        let historyProject = JSON.parse(JSON.stringify(state.historyProject)) || []
        if (!historyProject.some($project => {
          return $project.id === project.id
        })) {
          historyProject.push(project)
        }
        commit('setHistoryProject', historyProject)
        commit('setCheckedData', projectLIST_add)
      }
      commit('getPrice')
    }
    return true
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
  // getters
}
